// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"0c5699ca","183":"58b8a79a","275":"c1fc4911","367":"4b5e10a1","761":"245fadc7"}[chunkId] + ".chunk.js";
};